var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: { label: _vm.$ct("hide-grouped-contents") },
            model: {
              value: _vm.value.HideGroupedContents,
              callback: function ($$v) {
                _vm.$set(_vm.value, "HideGroupedContents", $$v)
              },
              expression: "value.HideGroupedContents",
            },
          }),
          _c(
            "w-sortable",
            {
              attrs: {
                "target-class": "handle",
                tag: "w-list",
                items: _vm.value.Groups,
              },
            },
            _vm._l(_vm.value.Groups, function (group, i) {
              return _c(
                "w-list-item",
                { key: i, attrs: { "show-handle": "" } },
                [
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.getGroupName(group))),
                  ]),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.edit"),
                              expression: "$ct('common.edit')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editGroup(group)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "pen" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("edit-style"),
                              expression: "$ct('edit-style')",
                            },
                          ],
                          on: {
                            click: function ($event) {
                              return _vm.editStyle(group)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "font" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("common.delete"),
                              expression: "$ct('common.delete')",
                            },
                          ],
                          staticClass: "danger",
                          on: {
                            click: function ($event) {
                              return _vm.removeGroup(i)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "w-list",
            [
              _vm.value.Groups.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(_vm.$ct("no-groups"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addGroup()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(" " + _vm._s(_vm.$ct("add-group")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditGroup != null } },
        [
          _vm.toEditGroup
            ? _c("app-grouping-edit", {
                attrs: {
                  model: _vm.model,
                  value: _vm.toEditGroup,
                  browse: _vm.browse,
                },
                on: {
                  input: function ($event) {
                    return _vm.editGroupConfirm($event)
                  },
                  close: function ($event) {
                    _vm.toEditGroup = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditGroupStyle != null } },
        [
          _vm.toEditGroupStyle
            ? _c("app-style-editor", {
                on: {
                  close: function ($event) {
                    _vm.toEditGroupStyle = null
                  },
                },
                model: {
                  value: _vm.toEditGroupStyle.Style,
                  callback: function ($$v) {
                    _vm.$set(_vm.toEditGroupStyle, "Style", $$v)
                  },
                  expression: "toEditGroupStyle.Style",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }